import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { Title } from '../components/blocks/Title';

export const isTitle = isElementType(Title);
